<template lang="pug">
.room-ranking-wrapper
  template(v-if="roomRank && roomRank.length > 0")
    .tournament-details-row(v-for="(item, index) in roomRank" :class="{ isme : item.isme == '1'}")
      .d-flex.justify-content-between.room-ranking-row(
        @click="roomStatus == 3 || getRecordLength(participants[item.ref]) > 0 ? showRecords(item) : ''"
      )
        .d-flex.align-items-center
          img.user-icon(src="/images/tournament/user-icon.svg") 
          span {{  item.member_id }}
        .d-flex.align-items-center.justify-content-end.flex-fill
          img.trophy-icon(v-if="[3].includes(roomStatus) && [1,2,3].includes(item.top_position)" :src="'/images/tournament/trophy' + item.top_position + '.svg'")
          b {{ $numeral(item.points).format("0,0.00") }}
        div(style="width: 10px;")
          i.far.fa-chevron-right.ms-1(v-if="roomStatus == 3 || getRecordLength(participants[item.ref]) > 0")
  template(v-else)
    .d-block.justify-content-between.room-ranking-row
      .text-center
        span {{ $t('message.no_information_available') }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    roomRank: {
      type: Array
    },
    participants: {
      type: Object
    },
    roomId: {
      type: Number
    },
    roomStatus: {
      type: Number
    }
  },
  computed: {},
  methods: {
    getRecordLength(item) {
      if (item && item.hasOwnProperty("bet_list")) {
        return item.bet_list.length;
      } else {
        return 0;
      }
    },
    showRecords(item) {
      var r = {
        id: item.ref,
        record: this.participants[item.ref],
        member_id: item.member_id,
        ranking: item.top_position,
        prize: item.points,
        room_id: this.roomId,
        room_status: this.roomStatus
      };
      EventBus.$emit("TN_PLAYER_BETSLIP", r);
    }
  }
};
</script>

<style>
.tournament-details-row.isme {
  background: #ffdd0088;
}
</style>
